module.exports = __webpack_public_path__ + "img/icon_light.3d52436a.png";